export default __webpack_public_path__ + "static/media/IconClose.cdd2fb53.svg";